//MODE : 0(로컬), 1(개발),  2(운영), 3(Internal)
export const commonConstants = {
    MODE: 2,
    API_URL: [
        'http://localhost:9090/opb_server/api',
        'http://15.165.102.230/opb_server/api',
        'http://3.34.121.97/opb_server/api',
        '/api',
    ]
};
